import StarPicker from '@liveauctioneers/caterwaul-components/lib/StarRating/StarPicker';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { useCallback, useState } from 'react';

import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';

const TOTAL_STARS_AMOUNT = 5;

type Props = {
    className?: string;
    onChange: any;
};

export const RatingInput = ({ className, onChange }: Props) => {
    const isMobile = useIsMobileLayout();
    const [hoverRating, setHoverRating] = useState(0);
    const [rating, setRating] = useState(0);

    const onClick = useCallback(
        (value: number) => {
            onChange(value);
            setRating(value);
        },
        [onChange]
    );

    return (
        <div className={cn('mt-xs flex', isMobile ? 'flex-col' : 'flex-row', className)}>
            <StarPicker
                onClick={onClick}
                onHover={setHoverRating}
                stars={TOTAL_STARS_AMOUNT}
            />
            <div className={cn('ratingCopy', isMobile ? 'mt-xs' : 'mx-2xs my-auto')}>
                {(rating > 0 || hoverRating > 0) && (
                    <BodyPrimary color="secondary">
                        <FormattedMessage id={`review_page.review_copy._${hoverRating ? hoverRating : rating}`} />
                    </BodyPrimary>
                )}
            </div>
        </div>
    );
};
